// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"01fe41fd","400":"1f1f6477","453":"315b638f","501":"a704c9c0","617":"8ec59d08","711":"07f025a7","775":"0323f34e"}[chunkId] + ".chunk.js";
};